import { Link } from 'react-router-dom'
import './index.scss'
import { useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect } from 'react'
import Logo from './Logo'
import Loader from 'react-loaders'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const nameArray = ['e', 'a', 'n', 'd', 'r', 'o']
  const jobArray1 = [
    'D',
    'e',
    's',
    'e',
    'n',
    'v',
    'o',
    'l',
    'v',
    'e',
    'd',
    'o',
    'r',
  ]
  const jobArray2 = ['F', 'r', 'o', 'n', 't', '-', 'e', 'n', 'd']

  useEffect(() => {
    setTimeout(() => {
      return setLetterClass('text-animate-hover')
    }, 7000)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>O</span>
            <span className={`${letterClass} _12`}>l</span>
            <span className={`${letterClass} _13`}>á</span>
            <span className={`${letterClass} _14`}>,</span>
            <br />
            <span className={`${letterClass} _15`}>m</span>
            <span className={`${letterClass} _16`}>e</span>
            <span className={`${letterClass} _17`}>u</span>
            <span className={`${letterClass} _18`}> </span>
            <span className={`${letterClass} _19`}>n</span>
            <span className={`${letterClass} _20`}>o</span>
            <span className={`${letterClass} _21`}>m</span>
            <span className={`${letterClass} _22`}>e</span>
            <span className={`${letterClass} _23`}> </span>
            <span className={`${letterClass} _24`}>é</span> <br />
            <span className={`logo`}>L</span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={25}
            />
            <span className={`${letterClass} _31`}>,</span>
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray1}
              idx={32}
            />{' '}
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray2}
              idx={45}
            />
          </h1>
          <Link to="/contato" className="flat-button">
            CONTATO
          </Link>
        </div>
        <Logo />
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Home
